// src/components/AboutUs.jsx

const AboutUs = () => {
  return (
    <section id="about">
      <h2>About Us</h2>
      <div className="about-text">
        <p>
          At KH Tiling & Painting, we bring strong hands-on expertise in
          professional tiling, painting, and surface preparation for both
          residential and commercial spaces. We are committed to delivering
          high-quality finishes through precise measurements, careful material
          selection, and close attention to detail. Safety, reliability, and
          craftsmanship guide every project, ensuring work is completed to the
          highest standard. With a proactive approach to problem-solving and a
          focus on meeting deadlines, KH Tiling & Painting has earned a
          reputation for dependable service and exceptional results.
          {/* You can replace this text with your own about info */}
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
